import { render, staticRenderFns } from "./ArticleInfoRibbon.vue?vue&type=template&id=066e6ce5&scoped=true"
import script from "./ArticleInfoRibbon.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoRibbon.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoRibbon.vue?vue&type=style&index=0&id=066e6ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e6ce5",
  null
  
)

export default component.exports